module.exports = __webpack_public_path__ + "img/mapTexture2.53986c03.jpg";